(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/adobe-target-payload-handler/assets/javascripts/send-view-payload.js') >= 0) return;  svs.modules.push('/components/components/adobe-target-payload-handler/assets/javascripts/send-view-payload.js'); "use strict";

const {
  checkIfDataAttributesExists,
  getDataAttributeValue,
  getAllDataAttributes
} = svs.components.adobeTargetPayloadHandler.helpers;
const logger = svs.core.log.getLogger('components:adobe-target-payload-handler'); 

const CRM_ANALYTICS_PAYLOAD_PE = 'crmAnalyticsPayloadPe';
const CRM_ANALYTICS_PAYLOAD_TNTA = 'crmAnalyticsPayloadTnta'; 

const CRM_MBOX = 'crmMbox';
const CRM_EVENT_TOKEN = 'crmEventToken';
const CRM_STATE = 'crmState';

const errorHandlerTarget = error => {
  logger.warn("call to target notification for DISPLAY went wrong ".concat(error.toString()), error);
};

const sendView = element => {
  const {
    display: targetDisplay
  } = svs.components.adobeTargetNotification;
  const {
    sendTargetPayload: sendAnalytics
  } = svs.components.analytics;

  if (checkIfDataAttributesExists(element, [CRM_ANALYTICS_PAYLOAD_PE, CRM_ANALYTICS_PAYLOAD_TNTA])) {
    const pe = getDataAttributeValue(element, CRM_ANALYTICS_PAYLOAD_PE);
    const tnta = getDataAttributeValue(element, CRM_ANALYTICS_PAYLOAD_TNTA);
    sendAnalytics({
      pe,
      tnta
    });
  }

  if (checkIfDataAttributesExists(element, [CRM_MBOX, CRM_EVENT_TOKEN, CRM_STATE])) {
    const mbox = getDataAttributeValue(element, CRM_MBOX);
    const token = getDataAttributeValue(element, CRM_EVENT_TOKEN);
    const state = getDataAttributeValue(element, CRM_STATE);
    targetDisplay({
      mboxName: mbox,
      tokens: [token],
      state,
      errorCallback: errorHandlerTarget
    });
  } else {
    logger.warn("Try to send target payload data but payload is missing! ".concat(getAllDataAttributes(element).toString()));
  }
};

svs.components.adobeTargetPayloadHandler.sendView = sendView;
 })(window);